import { createReducer } from '@reduxjs/toolkit'
import { Chapter, Rule, Section } from '../models/Rule'
import {
  setBookExtractPage,
  setChapterList,
  setCodeRules,
  setProjectName,
  setRuleList,
  updateSelectedChapter,
  updateSelectedRule,
  updateSelectedSection,
} from '../actions/rule'

interface ChapterState {
  chapters?: Chapter[]
  selectedChapter?: Chapter
  selectedSection?: Section
  selectedRule?: Rule
  rules?: any[]
  bookExtractPage?: string
  projectName?: string
  codeRules?: any
}

const initialState: ChapterState = {}

const ruleReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setChapterList, (state, action) => {
      state.chapters = action.payload
    })
    .addCase(updateSelectedChapter, (state, action) => {
      state.selectedChapter = action.payload
    })
    .addCase(updateSelectedSection, (state, action) => {
      state.selectedSection = action.payload
    })
    .addCase(setRuleList, (state, action) => {
      state.rules = action.payload
    })
    .addCase(setBookExtractPage, (state, action) => {
      state.bookExtractPage = action.payload
    })
    .addCase(setProjectName, (state, action) => {
      state.projectName = action.payload
    })
    .addCase(updateSelectedRule, (state, action) => {
      state.selectedRule = action.payload
    })
    .addCase(setCodeRules, (state, action) => {
      state.codeRules = action.payload
    })
})

export default ruleReducer
